<template>
  <div>
    <div class="digest__info">
      <p class="heading-tertiary-sub text--dark">Аналитический дайджест</p>
      <p class="paragraph--small">
        Серия аналитических дайджестов – это обзоры, посвященные актуальным и
        горячим темам от #FCBAnalytics.
      </p>
      <br />
      <p class="paragraph--small">
        <b>#FCBAnalytics</b> – аналитический центр Первого кредитного бюро,
        осуществляющий обработку статистических данных по финансовому рынку,
        рынку кредитования, а также другим сферам деятельности, влияющих на
        экономические и социальные показатели Казахстана.
      </p>
      <br />
      <p class="paragraph--small bold">
        При использовании материалов из дайджестов ссылка на аналитический центр
        Первого Кредитного бюро #FCBAnalytics обязательна.
      </p>
      <br />
      <p class="paragraph--small">
        По вопросам получения более расширенной аналитики обратитесь к
        <b>менеджеру.</b>
      </p>
    </div>
    <FilterDropdown
      label="Выберите год"
      class="mt--6"
      v-model="selectedYear"
      :options="availableYears"
    ></FilterDropdown>
    <div class="digest__cards">
      <template v-if="filteredReports.length > 0">
        <DigestCard
          v-for="(digest, index) in filteredReports"
          :key="index"
          :digest="digest"
        ></DigestCard>
      </template>
      <p v-else>Не найден дайджест за данный год</p>
    </div>
    <RequestReportForm :request-type="4">
      <p class="paragraph bold mb--2">
        Полная версия Аналитического дайджеста доступна на платной основе
      </p>
      <p class="paragraph mb--3">
        Заполните форму ниже, мы свяжемся с вами и расскажем вам об условиях
        получения дайджеста
      </p>
    </RequestReportForm>
  </div>
</template>

<script>
import DigestCard from "@/components/common/digest-card/DigestCard.vue";
import FilterDropdown from "@/components/common/FilterDropdown.vue";
import RequestReportForm from "@/views/visual-analytics/components/RequestReportForm.vue";

export default {
  components: {
    DigestCard,
    FilterDropdown,
    RequestReportForm,
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedYear: null,
      filteredReports: this.reports,
    };
  },
  computed: {
    availableYears() {
      return this.reports
        .map((el) => el.group_year)
        .filter((year, idx, arr) => {
          return arr.indexOf(year) == idx;
        })
        .sort((a, b) => a - b);
    },
  },
  watch: {
    selectedYear(newValue) {
      this.filteredReports = this.reports.filter(
        (el) => el.group_year == newValue
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.digest {
  &__cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));
    gap: 30px;
    margin-top: 65px;
    margin-bottom: 10rem;
  }
}
</style>
